import { DefaultService } from '@/services/DefaultService';

export default class TalhaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(area) {
        return this._http.post(`${this._env}/agro/field`, area, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/fields/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    changeSituacao(id) {
        return this._http.delete(`${this._env}/agro/field/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(uuidpropriedade, column, order, page = 0, limit = 50, situacao = 1, ...params) {
        return this._http.get(
            encodeURI(`${this._env}/agro/fields.json?page=${page}&limit=${limit}&column=${column}&order=${order}&propriedade=${uuidpropriedade}&situacao=${situacao}&param=${params}`), 
            this._headers
        ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllByArea(uuid, limit = 50, ...params) {
        return this._http.get(`${this._env}/agro/area/${uuid}/fields.json?limit=${limit}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    
    listAllByMultipleIdsAreas(uuidsAreas, limit = 50, page = 0, situacao = 2, ...params) {
        return this._http.post(`${this._env}/agro/propriedade/listbymultilpeareas.json?limit=${limit}&page=${page}&situacao=${situacao}&param=${params}`, uuidsAreas, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(...params) {
        // precisa da pesquisa e ORIGEMPDA
		return this._http.get(encodeURI(`${this._env}/agro/talhao/getcombo.json?param=${params}`), this._headers).then(res => {
            return res.body;
		}, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
		});
	}

    listAllByUnidadeMedida(page, limit, uuidplanosafra, idcliente, idunidademedida, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/propriedade/listproductivebyunidademedida.json?page=${page}&limit=${limit}&uuidplanosafra=${uuidplanosafra}&idcliente=${idcliente}&idunidademedida=${idunidademedida}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}